(() => {
  const viewer = document.querySelector('media-gallery slider-component');
  const list = viewer && viewer.querySelector('.product__media-list');
  if (!list) return;

  const dots = document.createElement('div');
  dots.className = 'pdp-dots';
  dots.setAttribute('aria-hidden', 'true');
  viewer.appendChild(dots);

  const benefit = document.querySelector('[data-pdp-benefit]');
  if (benefit) viewer.appendChild(benefit);

  let slides = [];
  let frame = null;

  // The badge always stays on one line: shrink the text until it clears the dots (never clip it).
  const fitBenefit = () => {
    if (!benefit) return;
    benefit.style.fontSize = '';
    benefit.style.letterSpacing = '';
    const limit = dots.hidden ? viewer.getBoundingClientRect().right - 14 : dots.getBoundingClientRect().left - 16;
    let size = parseFloat(getComputedStyle(benefit).fontSize);
    while (benefit.getBoundingClientRect().right > limit && size > 8) {
      size -= 0.5;
      benefit.style.fontSize = size + 'px';
      if (size <= 10) benefit.style.letterSpacing = '0.02em';
    }
  };

  const update = () => {
    frame = null;
    const visible = [...list.children].filter((item) => item.offsetWidth > 0);

    const rebuilt = visible.length !== slides.length;
    if (rebuilt) {
      dots.replaceChildren(
        ...visible.map(() => {
          const dot = document.createElement('span');
          dot.className = 'pdp-dots__dot';
          return dot;
        })
      );
    }
    slides = visible;
    dots.hidden = slides.length < 2;
    if (rebuilt) fitBenefit();

    const left = list.getBoundingClientRect().left;
    let current = 0;
    let best = Infinity;
    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - left);
      if (distance < best) {
        best = distance;
        current = index;
      }
    });
    [...dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === current));
    // The benefit badge belongs to the first slide only.
    if (benefit) benefit.classList.toggle('is-hidden', current !== 0);
  };

  const schedule = () => {
    if (frame === null) frame = requestAnimationFrame(update);
  };

  list.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', () => {
    fitBenefit();
    schedule();
  });
  new MutationObserver(schedule).observe(list, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'hidden'],
  });

  update();
})();
